import { useState } from "react"
import ActionMenu, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu"
import type { UserTenantFragment } from "@/v2-backoffice-client/user/tenant/__types__/user.tenant.fragment"
import TenantUserTypeSelectorDialog from "@/v2-backoffice-client/tenant/user/type/TenantUserTypeSelectorDialog"

export type TenantUserTypeSelectorDialogMenuItemProps = Omit<
  ActionMenuItemProps,
  "onClick"
> & {
  userTenant: UserTenantFragment
}

function TenantUserTypeSelectorDialogMenuItem(
  props: TenantUserTypeSelectorDialogMenuItemProps,
) {
  const { userTenant, children, ...menuItemProps } = props
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <ActionMenu.Item
        iconSrc="shuffle"
        onSelect={(e) => {
          e.preventDefault()
          setIsOpen(true)
        }}
        {...menuItemProps}
      >
        {children ?? "Change Team Role"}
      </ActionMenu.Item>

      <TenantUserTypeSelectorDialog
        open={isOpen}
        onOpenChange={setIsOpen}
        userTenant={userTenant}
      />
    </>
  )
}

export default TenantUserTypeSelectorDialogMenuItem
